import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Check } from '../../../internal/icons/small/Check';
import { makeStyles, createStyles, rgba } from '../../styles';
import { ListboxOption } from '../../Listbox/components';
import { ListItemIcon } from '../../ListItemIcon';
import { useComboboxContext } from '../Combobox.context';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        itemContent: {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            width: '100%',
        },
        iconContainer: {
            flex: '0 0 auto',
            width: '16px',
            marginRight: '12px',
        },
        multiSelected: {
            backgroundColor: 'transparent',
            color: 'inherit',
            '&:hover, &:focus': {
                backgroundColor: rgba(theme.palette.primary.main, 0.06), // Value from ListItem.overrides.ts
                color: 'inherit',
            },
        },
        selected: {
            textDecoration: 'underline',
        },
    });
});
export var MenuItem = function (props) {
    var children = props.children, option = props.option, selected = props.selected, _a = props.replaceContent, replaceContent = _a === void 0 ? false : _a, other = __rest(props, ["children", "option", "selected", "replaceContent"]);
    var comboboxProps = useComboboxContext().comboboxProps;
    var isMulti = comboboxProps.isMulti;
    var classes = useStyles(props);
    return (React.createElement(ListboxOption, __assign({ classes: __assign({}, (isMulti ? { root: classes.multiSelected } : { selected: classes.selected })), value: option.value, selected: selected, isMulti: isMulti }, other),
        replaceContent && children,
        !replaceContent && (React.createElement(React.Fragment, null,
            isMulti && (React.createElement(ListItemIcon, { className: classes.iconContainer }, selected && React.createElement(Check, null))),
            React.createElement("span", { className: classes.itemContent }, children)))));
};
export default MenuItem;
//# sourceMappingURL=Combobox.MenuItem.js.map